import { LogoWithTextColorised } from "#web/assets/LogoWithTextColorised";
import { i18nLike } from "#web/services/i18nLike";
import { BlockStack, Spinner, Text } from "@shopify/polaris";

import * as s from "./FullScreenAppLoader.css";

const en = {
  title: "Your protection against coupon leaks",
};

export const FullScreenAppLoader = () => {
  const t = i18nLike(en);

  return (
    <div className={s.FullScreenAppLoader}>
      <BlockStack align="center" gap="1600" inlineAlign="center">
        <BlockStack align="center" gap="200" inlineAlign="center">
          <div className={s.Logo}>
            <LogoWithTextColorised />
          </div>
          <Text as="h6" variant="headingLg">
            {t("title")}
          </Text>
        </BlockStack>
        <Spinner size="large" />
      </BlockStack>
    </div>
  );
};
